export const COPY_YEAR = "2020";
